import React, { ChangeEvent, FC } from "react";
import * as BoxModule from "@mui/material/Box/index.js";
import * as FormHelperTextModule from "@mui/material/FormHelperText/index.js";
import * as TextFieldModule from "@mui/material/TextField/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);
const FormHelperText = resolveDefault<any>(FormHelperTextModule);
const TextField = resolveDefault<any>(TextFieldModule);

interface TextAreaFieldProps {
	// id: string;
	label?: string;
	name: string;
	placeholder?: string;
	value?: string | number;
	error?: string | null;
	onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleBlur?: () => void;
	helperText?: string;
	disabled?: boolean;
}

const TextAreaField: FC<TextAreaFieldProps> = (props) => {
	return (
		<Box>
			<TextField
				multiline
				sx={{ color: "purple" }}
				// id={props.id}
				label={props.label}
				variant="outlined"
				placeholder={props.placeholder}
				name={props.name}
				value={props.value}
				onBlur={props.handleBlur}
				onChange={props.onChange}
				fullWidth={true}
				helperText={props.error}
				error={Boolean(props.error)}
				minRows={4}
				disabled={props.disabled}
			/>
			<FormHelperText> {props.helperText} </FormHelperText>
		</Box>
	);
};

TextAreaField.defaultProps = {
  label: "Multi line text input ..",
  name: "",
  placeholder: "",
  value: "",
  error: "",
  helperText: "Helper text",
};

export default TextAreaField;
